import { useEffect } from 'react'

import { useLocation } from '@tanstack/react-router'

import { analytics, NavigationEvents } from '@/lib/analytics'

export function usePageTracking() {
  const location = useLocation()

  useEffect(() => {
    analytics.track(NavigationEvents.PAGE_VIEWED, {
      path: location.pathname,
    })
  }, [location.pathname])
}
